import {useEffect, useRef} from 'react';
import * as CoreFns from '../utilities/CoreFns';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as NamingFns from '../utilities/NamingFns';
import * as TreeFunctions from '../utilities/TreeFunctions';
import * as FormSet from './FormSet';
import * as TypeChecks from '../TypeChecks';
import DropdownMenu from '../StockItems/DropdownMenu';
import NormalBtn from '../StockItems/NormalBtn';
import NormalIcon from '../StockItems/NormalIcon';
import NormalHint from '../StockItems/NormalHint';
import TableGrid from '../StockItems/TableGrid';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import SwitchToFormulaBit from './SwitchToFormulaBit';
import SmartContractList from './SmartContractList';
import PlayMusic from './PlayMusic';
import DoGuide from '../Tabs/DoGuide';

function App(props) {

  var aQuestion = props.aQuestion;
  var currentList = props.currentList;
  var header = props.header;
  var currentAnswer = props.currentAnswer;
  var userNos = props.userNos;
  var organicChanges = props.organicChanges;
  var error = props.error;
  var addToExtraScreen = props.addToExtraScreen;
  var depth = props.depth;
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;

  var answerHere = currentAnswer[aQuestion.i];
  var here = header.concat([aQuestion.i]);
  var thisLoc = here.join(' ');

  const ref1 = useRef();

  var errorLocString = '';
  if (error){
    errorLocString = error.loc.join(' ');
  }

  useEffect(()=>{
    leftColRefs[thisLoc] = ref1;
    setLeftColRefs({...leftColRefs});

    if (errorLocString === thisLoc){
      if (ref1 && ref1.current){
        ref1.current.scrollIntoView({ behavior: 'smooth' });
      }

    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  function doForm(questions, header, currentAnswer, depth){
    return FormSet.doForm(questions, header, currentAnswer, depth, currentList, userNos, organicChanges, error, addToExtraScreen, leftColRefs, setLeftColRefs)
  }


    var containerClass = 'container-fluid';

    function clickDropdown(here, actionOptions){
      return function(nos){
        var n = {};
        for (var i = 0; i < actionOptions.length; i++){
          if (actionOptions[i].i === nos){
            TreeFunctions.iterateThroughQuestionsInside(actionOptions[i].c, n, n, [], currentList,  here, '');
          }
        }
        var changes = [{t:'w',w:here.concat(['i']),n:nos},{t:'w',w:here.concat(['subs']),n}];
        organicChanges(changes);
      }
    }

    var type = CoreFns.getType(aQuestion.t, currentList, header);

    var titleLine = aQuestion.q;
    
      var errorLine = null;
      if (error){
        if (errorLocString === thisLoc){
          errorLine = <div style={{color:'red'}}> {error.t} </div>
        }
      }
//
  
      function normalResponse(core, secondLine, thirdLine, guideSet){

        var guide = null;
        if (guideSet){
          guide = <DoGuide addToExtraScreen={addToExtraScreen} set={guideSet} skipWrap={true}/>
        }
        var hintPiece = null;
        if (aQuestion.h){
          hintPiece = <NormalHint text={aQuestion.h} />
        }
//
        return <div ref={ref1} style={{marginBottom:10}}>{titleLine}<span>&nbsp;</span>{guide}{hintPiece}<br/>
                  {core}
                  {errorLine}
                  {secondLine}
                  {thirdLine}
              </div>
      }
//
    if (type.t === 'Boolean' || type.t === 'Text String' || type.t === 'UInteger' || type.t === 'Integer' || type.t === 'Address' || type.t === 'Decimal' || type.t === 'ListType' || type.t === 'Object'){

      function clickSelectRowFormula(e){
        addToExtraScreen({t:'responsiveEdit', title:aQuestion.q, path:here});
      }

      var core;
      var switchToFormulaLine = null;
      var typeSpecificLine = null;
      var guideSet = null;

      if (type.t === 'Text String'){
        guideSet = {t:'formulaOrDirect', v:type.t};
      }
//
      if (aQuestion.f){
        switchToFormulaLine = <SwitchToFormulaBit type={type} value={answerHere} organicChanges={organicChanges} currentList={currentList} path={here} clickSelectRowFormula={clickSelectRowFormula} />
      }
//
      if (answerHere === undefined){
          setTimeout(function(){ organicChanges([{t:'w',w:here,n:''}]);
          }, 1);
          return <div></div>
//
      }else if (answerHere.t === 'formula'){

        var valueCell = '';
//
        try{
          var vv = NamingFns.getTextOfAPath(currentList, here, type);
          if (vv.t){
            valueCell = vv.t;
          }
        }catch(err){

        }        
        if (valueCell.length < 3){
          valueCell = '  ' + valueCell + '  ';
        }

        core = <div style={{textDecoration:'underline', textAlign:'center', cursor:'pointer'}} onClick={clickSelectRowFormula}>{valueCell}</div>
//          
      }else{
      

       if (type.t === 'Boolean'){

          var thisAnswerBool = answerHere;
          if (!thisAnswerBool){
            thisAnswerBool = 0;
          }

          function setMultipleX(input){
            var changes = [{t:'w',w:here,n:input.i}];
            organicChanges(changes);            
          }

          var buttons = [{t:'True',i:1, ic:'dashicons:yes'}, {t:'False',i:0, ic:'dashicons:no'}];                
          if (type.v === 1){
            buttons = [{t:'Yes',i:1, ic:'dashicons:yes'}, {t:'No',i:0, ic:'dashicons:no'}];                
          }else if (type.v === 2){ //reversed
            buttons = [{t:'Yes',i:0, ic:'dashicons:yes'}, {t:'No',i:1, ic:'dashicons:no'}];                
          }else if (type.v === 3){
            buttons = [{t:type.yesAnswer,i:1, ic:type.yesIcon}, {t:type.noAnswer,i:0, ic:type.noIcon}];          
          }

          core = <TableGrid options={buttons} currentAnswer={thisAnswerBool} onClick={setMultipleX} />


//

        }else if (type.t === 'Object' || type.t === 'ListType'){

          if (!answerHere || typeof answerHere !== 'object'){
            setTimeout(function(){organicChanges([{t:'w',w:here, n:{}}]);}, 1);
            answerHere = {};
          }

          var beyondPieces3 = TreeFunctions.getQuestionsForObjectOrListType(currentList, type, aQuestion.f);
          var iR23 = doForm(beyondPieces3, here, answerHere, depth);
          if (iR23.length > 0){
            var objectListStyle = {marginTop:'5px'};
            if (type.t === 'Object'){
              objectListStyle.border = '1px solid #555';
            }
            core = <div className={containerClass} style={objectListStyle} >{iR23}</div>
          }
  //
        }else if (type.t === 'Text String' && type.sp === 'image'){

          var src = null;
          if (answerHere && answerHere.t === 'raw'){ //this is for legacy transitions.
            setTimeout(function(){organicChanges([{t:'w',w:here, n:answerHere.v}]);}, 1);
            answerHere = answerHere.v
          }else if (answerHere){
            src = answerHere;
          }

          function onClickImage(e){
            addToExtraScreen({t:'srcSelector', isFromScreen:aQuestion.isFromScreen, path:here});
          }
          core = <center><img alt='portrayal' src={src} onClick={onClickImage} style={{width:'95%', cursor:'pointer'}}/></center>
//
        }else if (type.t === 'UInteger' && type.sp === 'dateTime'){
          function postChange(date){
            var g = Math.floor(date.getTime()/1000);
            var changes = [{t:'w',w:here,n:g}];
            organicChanges(changes);
          }

          core = <DatePicker selected={answerHere * 1000} showTimeSelect dateFormat='dd/MM/yyyy HH:mm:ss' className='inputBoxClassLongDate' onSelect={postChange} onChange={postChange} minDate={new Date(1970,0,0,0,0,0,0)}/>
  //
        }else{
          function onChange(e){
            var changes = [{t:'w',w:here,n:e.target.value}];
            organicChanges(changes);
          }
          if (typeof answerHere === 'string' || answerHere instanceof String){
          }else{
            answerHere = ''
            var changes = [{t:'w',w:here,n:''}];
            organicChanges(changes);
          }

          if (type.t === 'Address'){

            function postSelect(newAddress){
              var changes = [{t:'w',w:here,n:newAddress}];
              organicChanges(changes);              
            }
            typeSpecificLine = <SmartContractList currentList={currentList} value={answerHere} postSelect={postSelect}/>
          }

          if (type.o){

            function clickDropdownX(x){
              var changes = [{t:'w',w:here,n:x}];
              organicChanges(changes);
            }

            typeSpecificLine = <div><br/><DropdownMenu clickItemInSelect={clickDropdownX} options={type.o} currentAnswer={answerHere}/></div>
          }
//
          core = <input className='form-control' onChange={onChange} value={answerHere}/>
        }
          //

      }

      return normalResponse(core, typeSpecificLine, switchToFormulaLine, guideSet);

//

    }else if (TreeFunctions.isDynamicChoice(type)){

      var filterOptions = TreeFunctions.actionOptionChoices(type, currentList, here);

      if (!answerHere || answerHere.i === undefined){
        answerHere = {i:'',subs:{}};
        if (type.t === 'Type'){
          answerHere.i = 'UInteger'
        }
        var cc3 = [{t:'w',w:here,n:answerHere}];
        setTimeout(function(){organicChanges(cc3);}, 1);
      }

      var followUp = null;
      for (var i = 0; i < filterOptions.length; i++){
        if (filterOptions[i].i === answerHere.i){
          followUp = <div className={containerClass} style={{marginTop:'5px'}} >{doForm(filterOptions[i].c, here.concat(['subs']), answerHere.subs, depth + 1)}</div>
//
        }
      }
      return normalResponse(<DropdownMenu clickItemInSelect={clickDropdown(here, filterOptions)} options={filterOptions} currentAnswer={answerHere.i}/>, followUp, null, null);

    }else if (type.t === 'Variable'){

      var ov = currentList.ov;
      var outputOVs = [];
      if (ov){
        var ovKeys = CoreFns.sortedKeyList(ov);
        ovKeys.forEach((anOVKey, index)=>{
          var thisOV = ov[anOVKey];
          var typeX = CoreFns.convertSelectionToType(thisOV.t, currentList);
          var pp = TypeChecks.checkMatch(typeX, type.type, true);   
          if (pp){
            outputOVs.push({i:'ov_' + anOVKey, a:CoreFns.iconFromType(type), n:thisOV.n})
          }       
        })
      }
      function clickDirect(v){
        var changes = [{t:'w',w:here,n:v}];
        organicChanges(changes);
      }

      var selector;
      if (outputOVs.length > 0){
        selector = <DropdownMenu clickItemInSelect={clickDirect} options={outputOVs} currentAnswer={answerHere}/>
      }else{
        selector = <p className='lead mb-0'>No Options available</p>
      }
//


      return normalResponse(selector, null, null, null);
//


      //logic is this - need to be starting with mapping or listtype to possibly have mapping. cos the others don't have subtypes and we have banned mappings from showing up in struct.
      // compliRow(aQuestion, (goDownTypeSeeGotMap(type) ? false : aQuestion.f), useWhat3, type, value, here, errorLine, null);
    }else if (type.t === 'Conditional'){
      var thisAnswer = '';
      if (answerHere){
        thisAnswer = answerHere.o;
      }

      function clickOption(value, addChangesFn){
          var addChanges = [];
          if (addChangesFn){
            addChanges = addChangesFn(value, here);
          }
          if (!answerHere){
            var toAdd = {o:value, c:{}};
            toAdd.c[value] = {};
            var changes = [{t:'w',w:here,n:toAdd}].concat(addChanges);
            organicChanges(changes);
          }else{
            var changes1 = [{t:'w',w:here.concat(['o']),n:value}];
            if (!answerHere.c[value]){
              changes1.push({t:'w',w:here.concat(['c', value]),n:{}});
            }
            organicChanges(changes1.concat(addChanges));
          }
        }
      
      var beyondPieces = [];

      var optionsList = type.o;
      optionsList.forEach((anOption, index)=>{
        if (thisAnswer === anOption.i) {
          beyondPieces = anOption.c;
        }
      })
      var useWhat= <DropdownMenu clickItemInSelect={clickOption} options={type.o} currentAnswer={thisAnswer}/>

      var insideRows2;
      if (beyondPieces.length > 0){
        insideRows2 = doForm(beyondPieces, here.concat(['c', thisAnswer]), answerHere.c[thisAnswer], depth + 1);
//
      }

      return normalResponse(useWhat, insideRows2, null, null)

    }else if (type.t === 'List'){

      function deleteAnswer(parentalDepth, i){
        return function(e){

          var changes = [{t:'r',w:parentalDepth,i}];
          organicChanges(changes);
        }
      }

    //
      if (!answerHere){
        setTimeout(function(){ organicChanges([{t:'w',w:here,n:{}}]);
        }, 1);
        return <div></div>
      }
//        
      var answerKeys = ResponsiveFns.sortAListBasedOnOrdNotStyle(answerHere);


      var pieces = answerKeys.map((aVarKey, index2)=>{

        function move(relevantIndex, direction){
          return function(e){
            var firstIndex = answerKeys[relevantIndex];
            var secondIndex = answerKeys[relevantIndex + direction];

            if (answerHere[firstIndex] && answerHere[secondIndex]){
              var firstOrd = answerHere[firstIndex].ord;
              var secondOrd = answerHere[secondIndex].ord;
              var changes1 = [{t:'w',w:here.concat([firstIndex, 'ord']),n:secondOrd}, {t:'w',w:here.concat([secondIndex, 'ord']),n:firstOrd}];
              organicChanges(changes1);
            }
          }
        }

        var rightIcons = [];
        rightIcons.push(<td onClick={deleteAnswer(here, aVarKey)} ><NormalIcon icon='fe:trash'  title='Delete'/></td>);

        if (+index2 > 0){
          rightIcons.push(<td onClick={move(+index2, -1)} > <NormalIcon icon='akar-icons:arrow-up' title='Move Up' /></td>);
        }
    //          
        if (+index2 < answerKeys.length - 1){
          rightIcons.push(<td onClick={move(+index2, +1)} > <NormalIcon icon='akar-icons:arrow-down' title='Move Down' /></td>);
    //
        }

    //
        var thisVariable = answerHere[aVarKey];
        var formPieces = doForm(type.c, here.concat([aVarKey]), thisVariable, depth + 1);
        return <div className='col-12'>
                  <table className='ml-auto'><tbody><tr>{rightIcons}</tr></tbody></table>
                  {formPieces}
                <hr style={{border:'1px solid #555'}}/>
        </div>
      });
    //

        function clickAddVariable(e){
            var uuid = CoreFns.uuidScoped(userNos, currentList, here, []);  
            var ord = ResponsiveFns.getNextOrdDirect(currentList, here);
            var addSet = {ord};
            TreeFunctions.iterateThroughQuestionsInside(aQuestion.t.c, addSet, addSet, [], currentList, here, uuid);
            var changes1 = [{t:'w',w:here.concat([uuid]),n:addSet}];
            organicChanges(changes1);

        }

      var listStyle = {color:'#CCC', padding:'5px', width:'100%'};
      if (depth > 0 && pieces.length > 0){
        listStyle.border = '1px solid #555555';
      }

     return  <div ref={ref1} style={listStyle}>
              {pieces}
              <center><NormalBtn icon='carbon:add' title={aQuestion.o} backScreen={true} onClick={clickAddVariable}/></center>
              {errorLine}
            </div>
//
    }else if (type.t === 'Execute'){
//
      function clickSubmit(e){
        if (error){
          if (type.doNotCheckError){
          }else{
            window.alert('Please resolve the errors in this contract first');
            return;
          }
        }
        type.f();
      }
      return <center ref={ref1} ><NormalBtn onClick={clickSubmit} title={aQuestion.q} backScreen={true} icon={type.ic}/></center>
//
    }else if (type.t === 'PlayMusic'){
      var thisSong = CoreFns.goDownPath(currentList, header.concat(['src']));
      return <PlayMusic url={thisSong} />
//
      
    }else if (type.t === 'Action'){
      return <div  ref={ref1} >Hello1</div>
//
    }else{

      valueCell = '';
      try{
        var vv1 = NamingFns.getTextOfAPath(currentList, here, type);
        if (vv1.t){
          valueCell = vv1.t;
        }
      }catch(err){

      }        
      function clickSelectRowFormula1(e){
        if (answerHere === undefined){
          var changes = [{t:'w',w:here,n:aQuestion.f}];
          organicChanges(changes);
        }
        addToExtraScreen({t:'responsiveEdit', title:aQuestion.q, path:here});
      }

      var errorLine2 = null;

      if (error){
        if (errorLocString === thisLoc){
          errorLine2 = <div style={{color:'red'}}> {error.t} [Click to Edit]</div>
        }
      }

      var hintPiece = null;
      var hintGap = null;
      if (aQuestion.h){
        hintPiece = <NormalHint text={aQuestion.h} />
        hintGap = <span>&nbsp;</span>
      }

//
      return <div ref={ref1}  className='col-12'>{aQuestion.q}{hintGap}{hintPiece}<br/>
                <div onClick={clickSelectRowFormula1} style={{cursor:'pointer'}}>
                  <div style={{textDecoration:'underline'}}>{valueCell}</div>
                  {errorLine2}
                </div>
            </div>
     // 
    }
}
//
//


export default App;
